var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"v1.2.209"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

import { User } from '@/api/auth';
import { CLIENT_ENVS } from '@/helpers/constants';
import { useGetCommonStore } from '@/store';

Sentry.init({
  dsn: CLIENT_ENVS.SENTRY_DSN,
  environment: CLIENT_ENVS.SENTRY_ENVIRONMENT,
  tracesSampleRate: 0.1,
  tracePropagationTargets: [/^https:\/\/levelupcasino\d*\.com/],
  integrations: [
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
  ],
  enabled: CLIENT_ENVS.SENTRY_ENVIRONMENT === 'production',
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  ignoreErrors: [
    /access-by-country-policy__confirm ng-scope/,
    /cg-notify-message ng-scope access-by-country-policy cg-notify-message-center/,
    /document\.getElementsByClassName\('gotya\d'\)\[0\]\.value/,
    /document\.getElementsByTagName\('video'\)\[\d\]\./,
    /ChunkLoadError/i,
  ],
  beforeSend(e) {
    // const useCommonStore = useGetCommonStore();

    // const { user } = useCommonStore.getState();

    const user = undefined as unknown as User;



    if (
      e.request != null &&
      e.request.url != null &&
      e.request.url.search(/game\/.+/) !== -1
    ) {
      return null;
    }

    const isSkipError = !!e.exception?.values?.find((value) => {
      return value.stacktrace?.frames?.find((frame) => {
        return (
          frame.filename?.includes('cdn.onesignal.com') ||
          frame.filename?.includes('iframe.a8r.games') ||
          frame.abs_path?.includes('assets.livespins.com/sdk/js/ls')
        );
      });
    });

    if (isSkipError) return null;
    if (user) {
      Sentry.setUser({ email: user?.email });
    }
    return e;
  },
});

import('@sentry/nextjs').then((lazyLoadedSentry) => {
  Sentry.addIntegration(
    lazyLoadedSentry.replayIntegration({ blockAllMedia: false })
  );
});
